/** Textos de la consola de roles: que hace cada rol y como se muestra su alcance. Solo presentacion. */
import type { RatRole } from '../auth/access';
import type { RoleAssignmentRow, RoleScopeType } from './queries';

/** Espejo en palabras de ROLE_PERMISSIONS (fase5/rbac.ts del backend). */
export const ROLE_DESCRIPTION: Record<RatRole, string> = {
  admin_rat: 'Administra usuarios, roles y catálogos, ve todo y puede revisar, aprobar y cerrar cualquier actividad.',
  revisor_rat:
    'Crea y edita actividades (asignándolas a una unidad de su alcance) y las revisa: las toma de la bandeja, observa, confirma las respuestas de las unidades, aprueba y decide el estado de la unidad.',
  jefe_unidad: 'Responsable de una unidad: edita, envía a revisión, responde observaciones y envía la unidad a revisión.',
  colaborador: 'Edita, envía a revisión y responde observaciones de las actividades de su unidad.',
  consulta: 'Solo lectura en su unidad.',
  auditor: 'Lee todo y la bitácora de auditoría. No modifica nada.',
};

export const SCOPE_TYPE_LABEL: Record<RoleScopeType, string> = {
  global: 'Toda la institución',
  unit_type: 'Una categoría de unidades',
  unit: 'Una unidad',
};

const UNIT_TYPE_LABEL: Record<string, string> = {
  direccion: 'Dirección',
  direccion_general: 'Dirección General',
  vicerrectoria: 'Vicerrectoría',
  secretaria_general: 'Secretaría General',
  contraloria: 'Contraloría',
  facultad: 'Facultad',
};

/** 'secretaria_general' -> 'Secretaría General'; un tipo nuevo sin traducir se capitaliza en lugar de mostrarse crudo. */
export function unitTypeLabel(t: string): string {
  const known = UNIT_TYPE_LABEL[t];
  if (known) return known;
  const s = t.replace(/_/g, ' ');
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** Alcance de una asignacion en palabras. */
export function scopeLabel(a: Pick<RoleAssignmentRow, 'scope_type' | 'scope_id' | 'scope_label' | 'include_descendants'>): string {
  if (a.scope_type === 'global') return 'Toda la institución';
  const base = a.scope_type === 'unit_type' ? `Categoría: ${unitTypeLabel(a.scope_id ?? '')}` : (a.scope_label ?? a.scope_id ?? '—');
  return a.include_descendants ? `${base} (y sus subunidades)` : base;
}
